import React from 'react'
import styles from './styles.css'
import { TextViewModelFragment } from '#src/generated/graphql'

export interface AttributedHtmlTextProps {
  text: TextViewModelFragment
  testId?: string
  [attributeKey: string]: any
}

const AttributedHtmlText: React.SFC<AttributedHtmlTextProps> = ({ text, testId, ...rest }) => {
  // N.B. String.prototype.split using a RegExp separator with capturing groups
  //   splices the captured groups into the returned array, but this behavior
  //   may not be supported in older versions of I.E.
  //
  //   See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/split#Capturing_parentheses
  const regex = /(\<\%[^(?:\%\>)]+\%\>)/
  const parts = text.text.split(regex)

  const content = parts.map(part => {
    const key = part.slice(2, -2).trim()

    if (regex.test(part)) {
      const attribute = (text.attributes || []).find(attr => attr.key === key)
      if (attribute && attribute.image) {
        const Glyph = require(`#src/assets/glyphs/${attribute.image.imagePath}`)

        return (
          <span className={styles.container} key={key}>
            <Glyph className={styles.icon} />
          </span>
        )
      }
    }
    return <span dangerouslySetInnerHTML={{ __html: part }} key={key} />
  })

  return (
    <span data-testid={testId} {...rest}>
      {content}
    </span>
  )
}

export default AttributedHtmlText
